import React from 'react'
import OptionsContainer from './OptionsContainer'

const Options = props => <OptionsContainer {...props} data-test="component-tradeIn-options" />

export default Options
